import { useSuspenseQuery } from '@connectrpc/connect-query'
import { getCustomer } from '@jotta/grpc-connect-openapi/customerQuery'

export function useSuspenseCustomer() {
  return useSuspenseQuery(getCustomer, {})
}
